import { Component, Input } from '@angular/core';

@Component({
  selector: 'mojo-item-index-ellipse',
  template: `
    <div>#{{ index }}</div>
  `,
  styleUrls: ['./item-index-ellipse.component.scss'],
})
export class ItemIndexEllipseComponent {
  @Input() index: number;
}
